<template>
  <el-form size="small" ref="formData" :model="formData" label-width="120px" :rules="rules">
    <el-form-item label="Account(Email)" prop="email">
      <el-input v-model="formData.email" autocomplete="new-password"></el-input>
    </el-form-item>
    <el-form-item label="Password" prop="password">
      <el-input v-model="formData.password" type="password" autocomplete="new-password"></el-input>
    </el-form-item>
    <el-form-item align="left" prop="device_list" label="Device list">
      <div style="display: inline">
        <el-input style="width: 60%" v-model="newDevice"></el-input> <el-button @click="addDevice()" class="el-button--primary">add</el-button>
      </div>
      <div v-for="(row,index) of formData.device_list" :key="index">
        <span>{{row}}<i style="color: red" class="el-icon-delete" @click="deleteDevice(index)"></i></span>
      </div>
    </el-form-item>
    <el-form-item align="left" prop="craftie_list" label="Craftie list">
      <!--<div style="display: inline">
        <el-input style="width: 60%" v-model="newCrafitie"></el-input> <el-button @click="addCraftie()" class="el-button&#45;&#45;primary">add</el-button>
      </div>
      <div v-for="(row,index) of formData.craftie_list" :key="index">
        <span>{{row}}<i style="color: red" class="el-icon-delete" @click="deleteCraftie(index)"></i></span>
      </div>-->
      <!--<el-select
        v-model="formData.craftie_list"
        multiple
        filterable
        remote
        reserve-keyword
        placeholder="please enter a keyword"
        :remote-method="remoteMethod"
        :loading="loading">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>-->
      <el-select
        v-model="formData.craftie_list"
        multiple
        placeholder="please select!">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item align="right">
      <el-button @click="$emit('closeDialog')">back</el-button>
      <el-button class="el-button--primary" @click="submit('formData')">save</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'CraftieIDWriteAdd',
    props:{
      closeDialog:Function,
      dialogSucc:Function
    },
    data(){
      return{
        pre:'5423431',
        newDevice:'',
        newCrafitie:'',
        options:[],
        loading: false,
        formData:{
          email:'',
          password:'',
          device_list:[],
          craftie_list:[],
        },
        rules:{
          email:[
            {required:true,message:'please input email!'},
            {pattern:/^([a-zA-Z0-9]+[_|\+|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,message:"please enter vaild email!"}
          ],
          password:[
            {required:true,message:'please input password!'}
          ],
          device_list:[
            {required:true,message:'please input a device!'}
          ],
          craftie_list:[
            {required:true,message:'please select a craftie!'}
          ]
        }
      }
    },
    created () {
      this.getCrafite()
    },
    methods:{
      deleteDevice(index){
        console.log(index)
        this.formData.device_list.splice(index,1)
      },
      getCrafite(){
        this.$api.rootV1.post('/web/craftie/public',{},
          (res)=>{this.options=res.data.flatMap(row=>{return {label:row.crafite_name,value:row.crafite_id}})});
      },
      addDevice(){
        if(this.newDevice.length!=0){
          this.formData.device_list.push(this.newDevice)
          this.newDevice=''
        }
      },
      deleteCraftie(index){
        console.log(index)
        this.formData.craftie_list.splice(index,1)
      },
      addCraftie(){
        this.formData.craftie_list.push(this.newCrafitie)
        this.newCrafitie=''
      },
      submit(formName){
        
        if(this.newDevice.length!=0){
          this.formData.device_list.push(this.newDevice)
          this.newDevice=''
        }
        //return console.log(JSON.stringify(this.formData))
        this.$refs[formName].validate(
          (valid)=>{
            if(valid){
              let params=JSON.parse(JSON.stringify(this.formData))
              //return console.log(JSON.stringify(params))
              let loading=this.$util.loading()
              this.$api.rootV1.post('/web/admin/writecrafiteid/add', params,
                (res) => {
                  this.$alert( 'added successfully!','info', {
                    confirmButtonText: 'confirm',
                    type:'success',
                    callback: action => {
                      loading.close()
                      this.$emit("dialogSucc")
                    }
                  })
                }, (res) => {
                  this.$alert( `add failed!${res.errmsg}`,'info', {
                    confirmButtonText: 'confirm',
                    type:'error',
                    callback: action => {
                      loading.close()
                      this.$emit("dialogSuc")
                    }
                  })
                })
            }else {
              this.$message.warning('Please check the input data!')
            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/craftieIdWrite/CraftieIDWriteAdd.vue